import { makeStyles } from '@material-ui/core';
import { useContext, useEffect } from 'react';
import { LanguageContext } from './LanguageProvider';

const useStyles = makeStyles(themes => ({
  lenguageSelector: {
    maringTop: 'auto',
    marginBottom: '2em',
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    color: 'white',
    fontSize: '0.9rem',
    fontFamily: 'inherit',
    fontWeight: 600,
    width: '10em',
    cursor: 'pointer',
  },
}));

export default function LanguageSelector() {
  const { userLanguage, userLanguageChange, dictionary } = useContext(
    LanguageContext
  );
  const classes = useStyles();

  // set selected language by calling context method
  const handleSelectSpanish = e => userLanguageChange('es');
  const handleSelectEnglish = e => userLanguageChange('en');

  useEffect(() => {
    let defaultLanguage = window.localStorage.getItem('rcml-lang');
    if (!defaultLanguage) {
      defaultLanguage = window.navigator.language.substring(0, 2);
    }
    userLanguageChange(defaultLanguage);
  }, [userLanguageChange]);

  return (
    <div className={classes.lenguageSelector}>
      <p className="Language-selector__es" onClick={handleSelectSpanish}>
        {dictionary['spanish']}
      </p>
      <span>|</span>
      <span className="Language-selector__en" onClick={handleSelectEnglish}>
        {dictionary['english']}
      </span>
    </div>
  );
}
